// extracted by mini-css-extract-plugin
export default {"saved_location":"SavedLocation_saved_location__XPBsA","heading":"SavedLocation_heading__duHmG","cards_container":"SavedLocation_cards_container__pKK0J"};